import { ParallaxData } from '../../core/modules/Parallax/ParallaxController';
import { RoadDetails } from '../levels/level';

export const ThemeName = {
  Test: 'test',
  City: 'city',
  CityAutumn: 'cityAutumn',
  CityNight: 'cityNight',
  CitySnow: 'citySnow',
  Park: 'park',
  ParkAutumn: 'parkAutumn',
  ParkNight: 'parkNight',
  ParkSnow: 'parkSnow',
  ParkVariant: 'parkVariant'
} as const;
export type ThemeNameKeys = keyof typeof ThemeName;
export type ThemeNameValues = typeof ThemeName[ThemeNameKeys];

export const Weather = {
  Dry: 'dry',
  Snow: 'snow',
  Wind: 'wind',
  Rain: 'rain'
};
export type WeatherKeys = keyof typeof Weather;
export type WeatherValues = typeof Weather[WeatherKeys];

export interface Theme {
  id: ThemeNameValues;
  texture: string;
  isNight: boolean;
  weather: WeatherValues;
  parallaxLayers: ParallaxData[];
  roadDetails: RoadDetails;
}
